export const appInitialState = {
  isInitialized: true,
  authToken: '',
  profileData: null,
};
